<template>
    <div :style="`height: ${height};`">
        <div class="float-right">
            <v-pagination
                v-model="page"
                :length="pageCount"
                :total-visible="totalVisible"
                class="mt-2 theme--light"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: "KimsaPagination",
    props: {
        height: {
            type: String,
            default: '60px'
        },
        pageCount: {
            type: [Number, String],
            default: 0,
        },
        totalVisible: {
            type: [Number, String],
            default: 5,
        },
    },
    data() {
        return {
            page: 1,
        }
    },
    watch: {
        page(val) {
            this.$emit('page', val)
        }
    }
}
</script>

<style scoped>

::v-deep.theme--light .v-pagination .v-pagination__item--active {
    color: #000000;
    font-weight: bold;
}

</style>